import {
  APP_OR_FALLBACK,
  CUSTOM,
  DEFAULT,
} from "../constants/OptionsConstants";

export const getRedirectType = (redirectURL) => {
  if (!redirectURL) return DEFAULT;

  const hasFallback = !!redirectURL.url;

  if (redirectURL.open_app_if_installed === true && hasFallback) {
    return APP_OR_FALLBACK;
  }

  if (redirectURL.open_app_if_installed === false && hasFallback) {
    return CUSTOM;
  }

  return DEFAULT;
};
